import script from "./SwordDesk.vue?vue&type=script&setup=true&lang=js"
export * from "./SwordDesk.vue?vue&type=script&setup=true&lang=js"

import "./SwordDesk.vue?vue&type=style&index=0&id=e500be52&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e500be52"]])

export default __exports__